﻿/// <reference path="../../Scripts/TypeScript/angularjs/angular.d.ts"/>
/// <reference path="../../Decorators.ts" />

namespace Umbrella.Search.Units {
    angular.module('Search').config([
        '$stateProvider',
        $stateProvider => {
            $stateProvider.state('search.units', {
                reloadOnSearch: true,
                url: '/eenheden?query',
                data: {
                    pageTitle: 'Eenheden',
                    authorize: ps => ps.customerCard
                },
                views: {
                    'center@search': {
                        templateUrl: '/Search/_Units/UnitOverview.html',
                        controller: 'UnitOverviewController'
                    }
                }
            });
        }
    ]);
}
